import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront3 from "assets/images/servicii/bgFront3.webp";
import bgBack3 from "assets/images/servicii/bgBack3.webp";

const advantages = {
    paragraphs: [
        "Externalizarea serviciilor de curățenie asigură optimizarea costurilor operaționale și eliminarea riscurilor asociate gestionării personalului intern. Beneficiarul este degrevat de procesele de recrutare, instruire și administrare a personalului, de gestionarea concediilor, precum și de achiziția, depozitarea și aprovizionarea constantă cu consumabile și materiale profesionale de curățenie.",
        "Prin colaborarea cu noi, sunt asigurate standarde ridicate de igienă și întreținere, prin intervenții planificate și adaptate specificului operațional și programului fiecărei locații. Activitățile sunt realizate de personal calificat, instruit periodic conform legislației în vigoare privind SSM și PSI, echipat cu echipamente de protecție adecvate și uniformă profesională.",
        "Pentru asigurarea controlului calității, fiecare contract beneficiază de un coordonator dedicat, responsabil de monitorizarea permanentă a fluxului operațional, verificarea conformității serviciilor cu caietul de sarcini și comunicarea eficientă cu beneficiarul.",
    ],
};

const advice = {
    paragraphs: [
        "Atenție! Înainte de selectarea unui furnizor de servicii de curățenie, este recomandată verificarea riguroasă a acestuia din surse multiple, având în vedere următoarele criterii: experiența operațională, portofoliul de clienți activi, numărul real de angajați cu contracte de muncă valide, stabilitatea financiară (cifra de afaceri) și existența eventualelor litigii.",
        "Aspirarea pardoselilor trebuie inclusă ca activitate zilnică, realizată de operatorul desemnat, conform procedurilor interne de lucru.",
        "Se recomandă utilizarea echipamentelor automatizate de tip aspirator robot profesional, programate să funcționeze concomitent cu personalul de întreținere sau în intervale orare fără activitate. Funcțiile de aspirare cu vibrație activă și filtrare avansată contribuie semnificativ la reducerea particulelor de praf și la îmbunătățirea calității aerului interior.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront image={bgFront3} icon="touch_app" title="Curățenie de întreținere" description="Intervenții planificate pentru un standard constant de curățenie." />
                            <RotatingCardBack image={bgBack3} title="Program adaptat" description="Solicită o evaluare gratuită." action={{ type: "internal", route: "/contact-curatenie", label: "cere o ofertă" }} />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
